import { useSyncExternalStore } from 'react'
import { PMState } from '../../../types/state'
import { PMSTATE } from '../../state'
import { pubSubMessages } from '../../state/pubSub'

const subMessagesState = (callback) => pubSubMessages.on(`state`, callback)

const getMessagesStateSelector = (key) => () => PMSTATE[key]

export const usePMSelector = <T extends keyof PMState>(
    attribute: T,
): PMState[T] => {
    return useSyncExternalStore(
        subMessagesState,
        getMessagesStateSelector(attribute),
        getMessagesStateSelector(attribute),
    )
}
